import { Link } from "react-router-dom";

import { useAppSettings } from "@skv/state";

import { useUserState } from "~/state";

import { ExternalLink } from "@skv/core";
import lockup from "~/assets/lockup.svg";

const CURRENT_YEAR = new Date().getFullYear();

export const Footer = (): JSX.Element => {
  const { seekVolunteerUrl } = useAppSettings();
  const { isAuthenticated } = useUserState();

  return (
    <footer className="nsw-footer mt-auto">
      <div className="nsw-footer__upper border-0 mb-4 mb-md-5">
        <div className="nsw-container d-flex flex-column flex-md-row gap-4 px-3">
          <div>
            <img
              src={lockup}
              alt="NSW Government in partnership with SEEK Volunteer"
              className="img-fluid"
              width="166"
              height="123"
            />
          </div>
          <nav className="ml-md-auto mt-auto small" aria-label="Secondary">
            <ul
              className="list-unstyled d-flex flex-column flex-md-row gap-2 gap-md-3"
              css={`
                li {
                  margin-top: 0;
                }
              `}
            >
              <li>
                <ExternalLink
                  href={seekVolunteerUrl + "/legal/terms-for-volunteers"}
                >
                  Terms of Use
                </ExternalLink>
              </li>
              <li>
                <ExternalLink
                  href={seekVolunteerUrl + "/legal/privacy-statement"}
                >
                  Privacy Statement
                </ExternalLink>
              </li>
              {!isAuthenticated && (
                <li>
                  <Link
                    to={(loc) => ({
                      pathname: "/volunteering/unsubscribe",
                      state: loc.state,
                    })}
                  >
                    Unsubscribe
                  </Link>
                </li>
              )}
              <li>
                <ExternalLink
                  href={seekVolunteerUrl + "/help-and-support/common-questions"}
                >
                  Help &amp; Support
                </ExternalLink>
              </li>
              <li>
                <ExternalLink href="https://www.seek.com.au/safe-job-searching">
                  Protect yourself online
                </ExternalLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="nsw-footer__lower">
        <div className="nsw-container">
          <p>
            We pay respect to the Traditional Custodians and First Peoples of
            NSW, and acknowledge their continued connection to their country and
            culture.
          </p>
          <hr />
          <div className="nsw-footer__info">
            <div className="nsw-footer__copyright fs-6">
              &copy; SEEK {CURRENT_YEAR}. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
